import { Report1915 } from "../../../components/borrowSystem/Report/Report1915";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";

export function Report1915Container() {
  const titleName =
    "แบบสรุปสถานประกอบกิจการที่กู้ยืมเงิน";
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <Report1915 />
      <Footer />
    </div>
  );
}
